import React from 'react';
import './MembershipPlansSection.css';
import membershipBg from '../../../assets/images/background_landing_mem.jpg';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const freeBenefits = [
  "Access to the introductory video and the possibility to register",
  "Access to the general layout of the tool.",
  "Limited view: only 1 city and 1 suburb for you to test the functionality.",
];

const premiumBenefits = [
  "States",
  "Cities",
  "Suburbs",
  "Price Cycle View",
  "Graphs and Tables",
  '"Big" View (Expanded View)',
];

const MembershipPlansSection = () => {
  const navigate = useNavigate();

  return (
    <section className="membership-section"
    style={{
      backgroundImage: `url(${membershipBg})`
    }}
    >
      <h2 className="membership-section__title">Choose a membership</h2>
      <p className="membership-section__subtitle">One simple plan unlocks everything</p>
      <div className="membership-section__plans">
        {/* Free Plan */}
        <div className="membership-card membership-card--free">
          <div className="membership-card__price">
            $0/month – Free
          </div>
          <hr className="membership-card__divider" />
          <div className="membership-card__badge membership-card__badge--free">
            <div>
              <div className="membership-card__badge-title">Free Membership</div>
              <div className="membership-card__badge-desc">
                Ideal for familiarising yourself with the platform
              </div>
            </div>
          </div>
          <div className="membership-card__includes">
            <strong>Includes:</strong>
            <div className="membership-card__desc">
              For users to be able to explore the interface and understand how it works at no cost
            </div>
            <ul>
              {freeBenefits.map((b, i) => (
                <li key={i}>
                  <CheckCircle className="membership-card__check membership-card__check--free" size={23} strokeWidth={2.3} />
                  {b}
                </li>
              ))}
            </ul>
          </div>
          <div className="membership-card__actions">
            <button
              className="membership-card__cta membership-card__cta--free"
              onClick={() => navigate('/signup')}
            >
              Get free membership
            </button>
            <div className="membership-card__note membership-card__note--free">
              <CheckCircle className="membership-card__check membership-card__check--free" size={23} strokeWidth={2.3} />
              Upgrade to premium anytime
            </div>
          </div>
        </div>

        {/* Premium Plan */}
        <div className="membership-card membership-card--premium">
          <div className="membership-card__price">
            $11.00/month
          </div>
          <hr className="membership-card__divider" />
          <div className="membership-card__badge membership-card__badge--premium">
            <span className="membership-card__premium-icon">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                <circle cx="17" cy="17" r="16" fill="#F6B800"/>
                <circle cx="17" cy="17" r="12" fill="white"/>
                <circle cx="17" cy="17" r="9" fill="#F6B800"/>
                <polygon points="17,12.5 20,17 17,21.5 14,17" fill="white"/>
              </svg>
            </span>
            <div>
              <div className="membership-card__badge-title">Premium Membership</div>
              <div className="membership-card__badge-desc">
                Full access to all sections and functionalities.
              </div>
            </div>
          </div>
          <div className="membership-card__includes">
            <strong>Includes:</strong>
            <div className="membership-card__desc">
              With this plan, you get unlimited access to all data and visualization tools, allowing you to dive deep into every geographical level and make the most of reports in graphs, tables, and price cycles.
            </div>
            <ul>
              {premiumBenefits.map((b, i) => (
                <li key={i}>
                  <CheckCircle className="membership-card__check membership-card__check--premium" size={23} strokeWidth={2.3} />
                  {b}
                </li>
              ))}
            </ul>
          </div>
          <div className="membership-card__actions">
            <button
              className="membership-card__cta membership-card__cta--premium"
              onClick={() => navigate('/membership')}
            >
              Get premium membership
            </button>
            <div className="membership-card__note-box">
              <span className="membership-card__note membership-card__note--premium">
                <CheckCircle className="membership-card__check membership-card__check--premium" size={23} strokeWidth={2.3} />
                Renews automatically
              </span>
              <span className="membership-card__note membership-card__note--premium">
                <CheckCircle className="membership-card__check membership-card__check--premium" size={23} strokeWidth={2.3} />
                Cancel anytime
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipPlansSection;
